import { ApiProperty } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';
import { IsISO8601, IsString, IsUUID } from 'class-validator';
import { BoardPurchasePartialDeliveryCreatableInterface } from '../interfaces/board-purchase-partial-delivery-creatable.interface';

@Exclude()
export class BoardPurchasePartialDeliveryCreateDto
  implements BoardPurchasePartialDeliveryCreatableInterface
{
  @ApiProperty({
    type: 'string',
    nullable: false,
    format: 'date-time',
    title: 'Partial Delivery Date',
    description: 'The date and time of this partial delivery',
  })
  @IsISO8601({ strict: true })
  @Expose()
  partialDeliveryDate!: Date | undefined;

  @ApiProperty({
    title: 'Notes',
    nullable: false,
    description: 'Notes',
  })
  @IsString()
  @Expose()
  notes!: string;

  @ApiProperty({
    format: 'uuid',
    title: 'Board Purchase Id',
    description: 'Board Purchase Id',
  })
  @IsUUID()
  @Expose()
  boardPurchaseId!: string;
}
